import React from 'react'

function ViewDocument({label, filepath, placeholder,required}) {

  return (
    <div className="mb-3">
        <label  className="form-label">{label}{required && <span className='mandatory-asterisk'>*</span>}</label><br/>
        {filepath && <a href={filepath} target="_blank" className="doc-link" rel="noopener noreferrer">{placeholder}</a>}
    </div>
  )
}

export default ViewDocument